<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-user-alt"></i>
        My Information
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">management</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Profile</a>
        </li>
      </ul>
    </div>
    <b-card>
    <div class="d-flex flex-wrap align-items-center">
      <div class="title mr-auto mb7">
        My Information
      </div>
      <div class="mb7">
        <span class="float-right">{{model.last_visit | datetime}}@{{model.last_addr || '-'}}</span>
      </div>
    </div>
    <hr>
    <b-row v-if="model.permissions == 1">
      <b-col md="12">
        <b-form-group class="text-center">
          <label for="ph_manage">Group Manage</label>
          <!-- <b-button block variant="primary" @click="redir" :disabled="lock"> go to  Group Manage ( {{model.groupname}} ) </b-button> -->
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
        <label class="col-form-label" for="ph_username" v-b-tooltip.hover title="Login ID.">
          E-Mail(ID)
        </label>
      </b-col>
      <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
        <b-form-input :disabled="true" type="text" id="ph_username" v-model="model.username" :plaintext="lock"></b-form-input>
      </b-col>
      <b-col class="col-xl-2 col-md-12  d-flex align-self-center">
        <label class="col-form-label" for="ph_nickname" v-b-tooltip.hover title="Nick name">
          Nick Name
        </label>
      </b-col>
      <b-col class="col-xl-4 col-md-12">
        <b-form-input type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-form-input>
      </b-col>
    </b-row>
    <b-row class="mb-2" v-show="!lock">
      <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
        <label class="col-form-label" for="ph_pass">
          Now Password
        </label>
      </b-col>
      <b-col class="col-xl-4 col-md-12">
        <b-form-input type="password" id="ph_pass" v-model="model.now_password" :plaintext="lock"></b-form-input>
      </b-col>
      <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
        <label class="col-form-label" for="ph_is_otp_use">
          OTP Active
        </label>
      </b-col>
      <b-col class="col-xl-4 col-md-12">
        <b-button block @click="genOtp()" :variant=" toggleOtp ? 'primary' : 'secondary'" :pressed.sync="toggleOtp" :disabled="lock"> {{toggleOtp ? 'Enabled' : 'Disabled' }} </b-button>
        <!-- <c-switch v-on:change="otp_active"  :disabled="lock" color="success" label variant="pill"/><br> -->
      </b-col>
    </b-row>
    <b-row class="mb-2" v-show="!lock">
      <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
        <label class="col-form-label" for="ph_pass_new">
          New Password
        </label>
      </b-col>
      <b-col class="col-xl-4 col-md-12">
        <b-form-input type="password" id="ph_pass_new" v-model="model.next_password" :plaintext="lock"></b-form-input>
        <b-badge v-if="model.next_password"  :variant="password_policy('number') ? 'success' : 'danger'"> Number </b-badge>
        <b-badge v-if="model.next_password"  :variant="password_policy('uppercase') ? 'success' : 'danger'"> Upper Characters </b-badge>
        <b-badge v-if="model.next_password"  :variant="password_policy('lowercase') ? 'success' : 'danger'"> Lower Characters </b-badge>
        <b-badge v-if="model.next_password"  :variant="password_policy('spacial') ? 'success' : 'danger'"> Special Characters </b-badge>
        <b-badge v-if="model.next_password"  :variant="password_policy('length') ? 'success' : 'danger'">
          Min Length : 10
        </b-badge>
        <!-- next_password == new_password -->
      </b-col>
      <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.next_password">
        <label class="col-form-label" for="ph_pass2">
          Password repeat
        </label>
      </b-col>
      <b-col class="col-xl-4 col-md-12" v-if="model.next_password">
        <b-form-input type="password" id="ph_pass2" v-model="model.new_password_repeat" :plaintext="lock"></b-form-input>
      </b-col>
    </b-row>
    <hr v-if="toggleOtp">
    <b-row class="mb-2 collapse">
      <b-col class="col-xl-6 col-md-12" v-if="toggleOtp">
        <b-form-group v-if="qrcode">
          <img class="mx-auto d-block" :src="qrcode" width="150">
        </b-form-group>
      </b-col>
      <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="toggleOtp && qrcode && !lock">
        <label class="col-form-label" for="ph_qrcode">OTP Code</label>
      </b-col>
      <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
        <b-form-input class="form-control" type="text" id="ph_qrcode" v-model="model.otp_pin" :plaintext="lock"></b-form-input>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col>
      </b-col>
    </b-row>
    <template v-if="lock">
      <template>
        <b-button class="float-right" size="sm" variant="warning" @click="edit"> Edit </b-button>
      </template>
    </template>
    <template v-else>
      <b-button size="sm" class="btn btn-add" @click="save"> Save </b-button>
      <b-button class="float-right" size="sm" variant="default" @click="cancel"> Cancel </b-button>
    </template>
    </b-card>
    <b-card>
      <log-Login-List v-if="model.id" :user="model"></log-Login-List>
    </b-card>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>